// @vendors
import { useState, useEffect, useContext } from "react";
import cx from "classnames";

// @context
import Context from "../../../context/appContext";

// @utils
import { getValueField, formatPrice } from "../../../utils/utils";

// @Components
import CollapseComponent from "../collapse";

// @styles
import "./styles.scss";
import { Button, Modal } from "antd";

export default function SidebarResume({ service }) {
  const {
    dataForm: { data, formResponses },
    priceToShow,
    fileRequest,
    setPriceToShow,
  } = useContext(Context);
  const plan = getValueField("coberturas", formResponses);
  const [priceValue, setPriceValue] = useState(plan ? Math.trunc(plan) : "0000");
  const [download, setDownload] = useState(false);
  const [openSidebar, setOpenSidebar] = useState(false);
  const currency = getValueField("monedaId", formResponses).toUpperCase();
  const [openDetail, setOpenDetail] = useState(false);

  useEffect(() => {
    if (!priceToShow) {
      setPriceToShow(priceValue);
    } else {
      setPriceValue(priceToShow);
    }
  }, [priceToShow]);

  const modal = (message, title) => {
    Modal.info({
      icon: "",
      title: title ? title : "Error",
      className: "modal-confirm",
      closable: true,
      okButtonProps: {
        className: "ant-btn-solid c-2 ant-btn-size-xs",
      },
      okText: "Aceptar",
      content: <p>{message}</p>,
      onOk() { },
    });
  };

  const objType = {
    "application/pdf": ".pdf",
  };

  const callService = async () => {
    console.log("data call service", data);
    if (data && data.modelConfig) {
      const modelConfig = data && data.modelConfig ? data.modelConfig : {};
      const options = JSON.parse(service);
      if (modelConfig && modelConfig.polizaCotizacion) {
        setDownload(true);
        const body = data.modelConfig.polizaCotizacion;
        const response = await fileRequest(
          options.url,
          options.headers,
          options.method,
          body
        );
        if (response && response.size > 0 && response.type) {
          const type = objType[response.type];
          const name = body["estado"] === "W" ? "cotizacion" : "emision";
          const a = document.createElement("a");
          a.href = window.URL.createObjectURL(response);
          a.download = `${name}-${modelConfig.polizaCotizacion.poliza}${type}`;
          a.click();
        } else {
          modal('No pudimos descargar el archivo. Vuelve a intentarlo más tarde.', 'Ups...');
        }
      }
    }
    setDownload(false);
  };

  return (
    <div
      className={cx("sidebar-resume", "sidebar-resume-completed", {
        "sidebar-resume-visible": openSidebar,
      })}
    >
      {priceValue ? (
        <div className='sidebar-resume__header'>
          <div className='sidebar-resume__price'>
            <p>
              {formatPrice(priceValue)}{" "}
              <strong className="currency-type">MXN</strong>
            </p>
            <span className="sidebar-resume__price-help">
              EL COSTO ANUAL SERÁ
            </span>
          </div>
        </div>
      ) : (
        <div className="sidebar-resume__load">
          Estamos generando tu cotización...
        </div>
      )}
      <CollapseComponent />
      {service && (
        <div
          className={`sidebar-resume__detail ${openDetail ? "open-detail" : ""}`}
        >
          <div className="sidebar-resume__detail-btn">
            <Button
              className="ant-btn-outline c-1 ant-btn-size-xxs download-button"
              onClick={() => callService()}
            >
              <em className="fal fa-download" />
              {download ? "Descargando..." : "Descarga tu cotización"}
            </Button>
          </div>
        </div>
      )}
      <div
        className="sidebar-resume__open"
        onClick={() => setOpenSidebar(!openSidebar)}
      >
        <em className="fal fa-chevron-down" />{" "}
        {openSidebar ? "Ver menos" : "Ver más"}
      </div>
    </div>
  );
}
